module.exports = __webpack_public_path__ + "img/grass_thumb.7414b5cd.jpg";